export const defaultSizeChart = {
  emptyText: 'See results once filled out.',
  fitsText: 'Size {size} fits:',
  band: {
    label: 'Band',
    options: ['30', '32', '34', '36', '38', '40', '42', '44', '46', '48'],
  },
  cup: {
    label: 'Cup',
    options: [
      { value: 'A', label: 'A' },
      { value: 'B', label: 'B' },
      { value: 'C', label: 'C' },
      { value: 'D', label: 'D' },
      { value: 'DD', label: 'DD / E' },
      { value: 'DDD', label: 'DDD / F' },
      { value: 'G', label: 'G' },
      { value: 'H', label: 'H' },
      { value: 'I', label: 'I' },
    ],
  },
  result: {
    label: 'Size',
    sizes: [
      { display: 'S', fits: ['30A', '30B', '30C', '32A', '32B', '34A'] },
      { display: 'M', fits: ['30D', '30DD', '32C', '34B', '34C', '36A', '36B', '38A'] },
      { display: 'L', fits: ['30DDD', '32DD', '32DDD', '34D', '34DD', '36C', '36D'] },
    ],
  },
};

export const escapeHtml = str =>
  String(str ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

// JSON is stored in a single-quoted attribute, so & and ' must be escaped
export const serializeSizeChart = sizeChart =>
  JSON.stringify(sizeChart)
    .replace(/&/g, '&amp;')
    .replace(/'/g, '&#39;');

export const placeholderOption = label => `<option value="" selected>${escapeHtml(label)}</option>`;

export const renderBandOptions = band =>
  placeholderOption(band.label) +
  (band.options || []).map(value => `<option value="${escapeHtml(value)}">${escapeHtml(value)}</option>`).join('');

export const renderCupOptions = cup =>
  placeholderOption(cup.label) +
  (cup.options || []).map(o => `<option value="${escapeHtml(o.value)}">${escapeHtml(o.label)}</option>`).join('');

export const renderSizeOptions = result =>
  placeholderOption(result.label) +
  (result.sizes || []).map(s => `<option value="${escapeHtml(s.display)}">${escapeHtml(s.display)}</option>`).join('');
